import styled, { css } from 'styled-components';
import { device } from '../../../../../ui-components/breakpoints';
import { regularBlack, regularWhite } from '../../../../../ui-components/design-tokens';
import { Heading3 } from '../../../../../ui-components/typography/Heading.styles';
import { regularOutline } from '../../../../../ui-components/typography/helpers';
import { ClearFix } from '../../../../../ui-components/utils.styles';

export const StyledContainer = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    background-color: ${regularBlack};
`;

export const StyledEndScreenRecommendations = styled.div`
    pointer-events: all;
    position: absolute;
    margin: auto;
    top: 50%;
    left: 50%;
    min-width: 142px;
    transform: translate(-50%, -50%);
    width: 95%;
`;

export const StyledItems = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: baseline;
    margin: auto;
    user-select: none;
`;

export const StyledThumbnailImage = styled.img`
    width: 100%;
`;

export const StyledHeader = styled(Heading3)`
    margin-bottom: 0.35em;
`;

export const StyledItemLink = styled.a`
    ${ClearFix}
    color: ${regularWhite};
    text-align: left;
    text-decoration: none;
    display: inline-block;
    vertical-align: top;
    margin: 8px 2px 0 2px;
    width: auto;
    max-width: 50%;
    opacity: 0;
    transform: translate(0, 55%);
    transition: 0.5s cubic-bezier(0.25, 0.1, 0.25, 1);

    &:nth-last-of-type(3) {
        transition-delay: 0s;
    }

    &:nth-last-of-type(2) {
        transition-delay: 0.1s;
    }

    &:nth-last-of-type(1) {
        display: none;

        @media ${device.GteSmall} {
            display: inline-block;
            transition-delay: 0.2s;
        }
    }

    &:focus,
    &:hover {
        outline: none;

        ${StyledHeader} {
            text-decoration: underline; 
        }
    }

    &:focus ${StyledThumbnailImage} {
        ${regularOutline(2)}
    }

    &:first-of-type {
        margin-top: 0;
    }

    @media ${device.GteSmall} {
        display: block;
        flex: 1;
        width: auto;
        margin: 0 3px;
        max-width: 33%;
    }

    ${(props) =>
        props.imageLoaded &&
        css`
            opacity: 1;
            transform: translate(0, 0);
        `}
`;

export const StyledThumbnail = styled.div`
    display: block;
    transform: translate3d(0, 0, 0);
    float: left;
    width: 100%;
    max-width: 100%;
    margin-left: auto;
    margin-bottom: 10px;
    text-align: center;

    @media ${device.GteSmall} {
        width: 100%;
        margin-left: auto;
        max-width: 100%;
        text-align: center;
        margin-bottom: 10px;
    }
`;

export const StyledThumbnailWrapper = styled.span`
    display: inline-block;
    position: relative;
    line-height: 0;
    width: 100%;
`;
